import { useAppDispatch, useAppSelector } from '../../hooks';
import React, { useCallback, useState } from 'react';
import styles from '../../styles/Popup/Popup.module.css';
import Popup from './Popup';
import { Btn } from '../../styles/Button.styled';
import PasswordInput from './PasswordInput';
import { SIGN_RESET } from '../../actions/sign';
import { CircularProgress } from '@mui/material';
import { useMediaQuery } from 'react-responsive';
import DropzoneWithLabel from './Dropzone';
import { fileAuth } from '../../actions/auth';
// import { ErrorSpan } from '../../styles/Login.styled';

export function FileSignPopup(props: FileSignPopupProps) {
  const dispatch = useAppDispatch();
  const [activeButton, setActiveButton] = useState(false);
  const [uploadKey, setUploadKey] = useState(null);
  const [checkExtension, setCheckExtension] = useState(true);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const auth = useAppSelector((state) => state.auth);

  const handleFileDrop = (e) => {
    setUploadKey(e[0]);
  };

const closePopup = useCallback(
  (e: React.MouseEvent) => { 
    e.preventDefault();
    if (props.clickCloseButton) {
      props.clickCloseButton();
    }
  }, 
  [props.clickCloseButton] 
);


  const inputChange = useCallback(
    (e) => {
      setActiveButton(!!uploadKey && checkExtension && e.currentTarget.value.length > 0);
      if (props.sign?.state === 'failure') {
        dispatch({ type: SIGN_RESET });
      }
    },
    [props?.sign, uploadKey],
  );

  const submitForm = (e) => {
    e.preventDefault();

    if (uploadKey) {
      const data = new FormData(e.currentTarget);
      const key = Object.fromEntries(data.entries());
      const reader = new FileReader();

      if (props.onSubmit) {
        reader.onloadend = () => {
          props.onSubmit({
            ...key,
            file: btoa(reader.result),
            name: uploadKey.name,
          });
        };
        reader.readAsBinaryString(uploadKey);
      }

      if (props.login) {
        reader.onloadend = () => {
          dispatch(
            fileAuth(
              {
                ...key,
                file: btoa(reader.result),
                name: uploadKey.name,
              },
            ),
          );
        };
        reader.readAsBinaryString(uploadKey);
      }
    }
  };
  
  return (
    <Popup
      clickCloseButton={props.clickCloseButton}
      className={props.className}
    >
      <h1>
        {props.login ? 'Увійти за допомогою КЕП' : 'Підписання КЕП'}
      </h1>
      <p>Завантажте файловий КЕП і введіть пароль до ключа</p>

      <form onSubmit={submitForm} className={styles.keyform}>
        <div className={styles.mb14}>
          <DropzoneWithLabel
            checkExtension={checkExtension}
            setCheckExtension={setCheckExtension}
            onFileDrop={handleFileDrop}
            uploadKey={uploadKey}
            isMobile={isMobile}
          />
        </div>


        <PasswordInput
          passwordChange={inputChange}
          disabled={!uploadKey || !checkExtension}
          $heightMobile={'47px'}
          $marginBottom = {'0'}
          activeButton
        />
        
        <span className={styles.error}>
          {props.sign?.state === 'failure' ?
            props.sign.result?.message : auth.result?.message
          }
        </span>
        <div  style={{display:"flex", gap: "10px"}}>
          <Btn
            type="button"
            $width="100%"
            $color="var(--blue)"
            // $height={isMobile ? '40px' : '47px'}
            $marginTop="0"
            onClick={closePopup}
            $background='var(--sidebar-hover)'
            $heightMobile="47px"
          >
            Відмінити
          </Btn>

          <Btn
            type="submit"
            disabled={!activeButton || props.sign?.state === 'loading'}
            $width="100%"
            $marginTop="0"
            $background='var(--blue)'
            $disabledColor='var(--disabled-c)'
            $disabledC='var(--white)'
            $heightMobile="47px"
          >
            {(props.sign?.state === 'loading' || auth.state === 'loading') ? (
              <CircularProgress
                size={24}
                sx={{
                  color: 'var(--white)',
                }}
              />
            ) : (
              <> {props?.login ? 'Увійти' : 'Підписати'}</>
            )}
          </Btn>
        </div>
      </form>
    </Popup>
  );
}
